"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _StagedSettingsChanges = _interopRequireDefault(require("./StagedSettingsChanges"));

var _default = (0, _immutable.Record)({
  namespaceCollision: false,
  defaultLinkId: null,
  stagedChanges: new _StagedSettingsChanges.default()
}, 'EditSettingsConfig');

exports.default = _default;
module.exports = exports.default;